import React, { useEffect, useState, useRef } from 'react';
interface StickyButtonProps {
  targetRef: React.RefObject<HTMLElement>;
  onClick: () => void;
}
export const StickyButton: React.FC<StickyButtonProps> = ({
  targetRef,
  onClick
}) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting || entry.boundingClientRect.top < 0);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    if (targetRef.current) {
      observer.observe(targetRef.current);
    }
    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, [targetRef]);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-gray-200 shadow-lg md:hidden" data-id="element-287">
      <a href="https://stresslessdogs.nl/mcc-gsearch-adv2" className="block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 text-center" target="_blank" rel="noopener noreferrer" data-id="element-288">
        Volg vandaag GRATIS het Webinar: Communiceren met je Hond
      </a>
    </div>;
};